import { render, staticRenderFns } from "./InsuranceSkladUsaCreation.vue?vue&type=template&id=4871f8f8&scoped=true"
import script from "./InsuranceSkladUsaCreation.vue?vue&type=script&lang=js"
export * from "./InsuranceSkladUsaCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871f8f8",
  null
  
)

export default component.exports